import { EyeIcon } from '@phosphor-icons/react';
import { T, Var } from 'gt-react';
import { Button } from '@/components/ui/button';

/**
 * The review grid's way back from hiding: bring back the rows the reader hid
 * (review-wide, so the count is how many sit on this page) and the worksheet's
 * hidden columns, each shown only while there is something to bring back.
 * Rows and columns hide from the grid's context menu.
 */
export function As400GridHidingControls({
  hiddenRowCount,
  onShowRows,
  hiddenColumnCount,
  onShowColumns,
}: {
  /** How many rows are hidden on this page. */
  hiddenRowCount: number;
  /** Show every hidden row; absent when nothing is hidden anywhere. */
  onShowRows: (() => void) | undefined;
  hiddenColumnCount: number;
  onShowColumns: () => void;
}) {
  return (
    <>
      {onShowRows && (
        <Button variant="outline" size="sm" onClick={onShowRows}>
          <EyeIcon className="h-4 w-4" />
          {hiddenRowCount > 0 ? (
            <T context="review grid toolbar: show the rows the user hid, with how many are hidden on this page">
              Show hidden rows (<Var>{hiddenRowCount}</Var>)
            </T>
          ) : (
            <T context="review grid toolbar: show the rows the user hid (none of them are on this page)">
              Show hidden rows
            </T>
          )}
        </Button>
      )}
      {hiddenColumnCount > 0 && (
        <Button variant="outline" size="sm" onClick={onShowColumns}>
          <EyeIcon className="h-4 w-4" />
          <T context="review grid toolbar: show the worksheet columns the user hid, with how many are hidden">
            Show hidden columns (<Var>{hiddenColumnCount}</Var>)
          </T>
        </Button>
      )}
    </>
  );
}
